import { LanguageService } from '$core/services/language.service';
import { SeoService } from '$core/services/seo.service';
import { environment } from '$env/environment';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
// import * as Sentry from '@sentry/browser';
import * as dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/be';
import 'dayjs/locale/en';

declare global {
  interface Window {
    moment: typeof dayjs;
  }
}

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private languageService: LanguageService,
    private meta: Meta,
    protected seoService: SeoService
  ) {
    const locale =
      this.languageService.currentLang === 'by'
        ? 'be'
        : this.languageService.currentLang;
    dayjs.locale(locale);
    window.moment = dayjs;
  }

  public ngOnInit() {
    // if (environment.sentry && !window['webpackHotUpdate']) {
    //   Sentry.init({
    //     dsn:
    //       'https://946fe29432854c2faa2ae4e866c2476d@mysentry.naveksoft.com/17',
    //     environment: environment.name,
    //     release: 'blog',
    //     ignoreErrors: [
    //       // Applivation specific
    //       'Loading chunk',
    //       'Unexpected token <',
    //       'Non-Error exception captured',
    //       'Expression has changed after it was checked',
    //       // Random plugins/extensions
    //       'top.GLOBALS',
    //       // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    //       'originalCreateNotification',
    //       'canvas.contentDocument',
    //       'MyApp_RemoveAllHighlights',
    //       'http://tt.epicplay.com',
    //       "Can't find variable: ZiteReader",
    //       'jigsaw is not defined',
    //       'ComboSearch is not defined',
    //       'http://loading.retry.widdit.com/',
    //       'atomicFindClose',
    //       // Facebook borked
    //       'fb_xd_fragment',
    //       // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    //       // reduce this. (thanks @acdha)
    //       // See http://stackoverflow.com/questions/4113268
    //       'bmi_SafeAddOnload',
    //       'EBCallBackMessageReceived',
    //       // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    //       'conduitPage',
    //     ],
    //     blacklistUrls: [
    //       // Facebook flakiness
    //       /graph\.facebook\.com/i,
    //       // Facebook blocked
    //       /connect\.facebook\.net\/en_US\/all\.js/i,
    //       // Woopra flakiness
    //       /eatdifferent\.com\.woopra-ns\.com/i,
    //       /static\.woopra\.com\/js\/woopra\.js/i,
    //       // Chrome extensions
    //       /extensions\//i,
    //       /^chrome:\/\//i,
    //       // Other plugins
    //       /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    //       /webappstoolbarba\.texthelp\.com\//i,
    //       /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    //     ],
    //     integrations(integrations) {
    //       return integrations.filter(i => i.name !== 'TryCatch');
    //     },
    //     debug: false,
    //   });
    // }

    // IntersectionObserver polyfill settings
    if (IntersectionObserver) {
      (<any>IntersectionObserver).prototype.USE_MUTATION_OBSERVER = false; // Prevents perfomance issue
    }
  }

  public ngAfterViewInit() {
    // Был добавлен false, т.к с 1 июля 2023 сервис перестал обрабатывать данные
    if (
      false &&
      environment.gtag &&
      !window['webpackHotUpdate'] &&
      !navigator.webdriver
    ) {
      this.appendGoogleAnalytics();
    }

    // Был добавлен false, т.к с 1 июля 2023 сервис перестал обрабатывать данные
    // Вернули по задачам https://naveksoft.atlassian.net/browse/BSD-51 и https://naveksoft.atlassian.net/browse/BN-5540
    if (
      environment.gtm &&
      !window['webpackHotUpdate'] &&
      !navigator.webdriver
    ) {
      this.appendGoogleTagManager();
    }

    if (
      environment.metrika &&
      !window['webpackHotUpdate'] &&
      !navigator.webdriver
    ) {
      this.appendYandexMetrika();
    }

    if (!environment.indexing) {
      this.meta.addTag({ name: 'robots', content: 'noindex' });
    }
  }

  private appendGoogleAnalytics() {
    if (!environment.gtag) {
      return;
    }

    const id = (<any>environment.gtag).blog;
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    script.async = true;
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}', {
        'linker': {
          'domains': ['belpost.by']
        }
      });`;
    document.head.appendChild(script2);
  }

  private appendGoogleTagManager() {
    if (!environment.gtm) {
      return;
    }

    const id = (<any>environment.gtm).site;
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
      {'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${id}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
      height="0"width="0"style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }

  private appendYandexMetrika() {
    if (!environment.metrika) {
      return;
    }

    const id = (<any>environment.metrika).blog;

    // tslint:disable: max-line-length
    const script = document.createElement('script');
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function()
      {(m[i].a=m[i].a||[]).push(arguments)}
      ;   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");   ym(${id}, "init",
      {        clickmap:true,        trackLinks:true,        accurateTrackBounce:true   }
      );
    `;
    // tslint:enable: max-line-length
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${id}" style="position:absolute; left:-9999px;" alt="" /></div>`;
    document.head.appendChild(noscript);
  }
}
